import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import FromFieldText from '../../../atoms/FromFieldText';
import FromSpFieldTextArea from '../../../atoms/FromSpFieldTextArea';
import { getAllocationLog } from '../../../services/asset.service';
import { getDivisionList } from '../../../services/user.service';
import * as CryptoJS from "crypto-js";

/* ─── Shared Asset List & Info CSS ─── */
import '../../ExcelUploads/AssetInfo/AssetInfo.css';
import '../../ExcelUploads/AssetInfo/AssetList.css';

function getFormatedDate(dateString) {
    if (dateString) {
        let dte = new Date(dateString);
        if (isNaN(dte.getTime())) return '';
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
    } else {
        return '';
    }
}

function AllocationLogDetails() {
    const [ainNo, setAinNo] = useState('');
    const [tag, setTag] = useState('');
    const [division, setDivision] = useState('');
    const [divisions, setDivisions] = useState([]);
    const [premises, setPremises] = useState('');
    const [floor, setFloor] = useState('');
    const [siteId, setSiteId] = useState('');
    const [rackId, setRackId] = useState('');
    const [userType, setUserType] = useState('');
    const [userDepartment, setUserDepartment] = useState('');
    const [employeeId, setEmployeeId] = useState('');
    const [employeeName, setemployeeName] = useState('');
    const [userMailId, setUserMailId] = useState('');
    const [reason, setReason] = useState('');
    const [effectivedate, setEffectiveDate] = useState('');
    const [financialsClassification, setFinancialsClassification] = useState('');

    const navigate = useNavigate();
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag');
    const LogId = query.get('LogId');

    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };
        getDivisionList(oData).then(res => {
            if (res?.data?.data?.length) setDivisions(res.data.data);
        });
    }, []);

    useEffect(() => {
        if (Tag !== '' && Tag !== null && LogId !== '' && LogId !== null) {
            try {
                const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                const decryptedTag = decrypt_data.tag;

                const decryptedLogBytes = CryptoJS.AES.decrypt(LogId.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                const decrypt_log = JSON.parse(decryptedLogBytes.toString(CryptoJS.enc.Utf8));
                const decryptedLogId = decrypt_log.log_id;

                getTagAssetInfo(decryptedTag, decryptedLogId);
            } catch (err) {
                console.error("Error decrypting parameters:", err);
            }
        }
    }, [Tag, LogId]);

    const getTagAssetInfo = function (decryptedTag, decryptedLogId) {
        let obj = { 'tag': decryptedTag, 'logid': decryptedLogId };
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': obj,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };

        getAllocationLog(oData).then(function (res) {
            if (res?.data?.data?.length) {
                var Info = res.data.data[0];
                setAinNo(Info.ain_no || Info.ain || '');
                setTag(Info.tag || '');
                setDivision(Info.division || '');
                setPremises(Info.premises || '');
                setFloor(Info.floor || '');
                setSiteId(Info.site_id || '');
                setRackId(Info.rack_id || '');
                setUserType(Info.user_type || '');
                setUserDepartment(Info.user_department || '');
                setEmployeeId(Info.employee_id || '');
                setemployeeName(Info.employee_name || '');
                setUserMailId(Info.user_mail_id || '');
                setFinancialsClassification(Info.financials_classification || Info.alternative_verification || '');
                setReason(Info.reason || '');
                const rawDate = Info.effective_date != null ? Info.effective_date : Info.unallocate_date;
                setEffectiveDate(getFormatedDate(rawDate));
            }
        });
    };

    const getTagInfo = function () {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': tag },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };

        getAllocationLog(oData).then(function (res) {
            if (res?.data?.data?.length) {
                var Info = res.data.data[0];
                setAinNo(Info.ain_no || Info.ain || '');
                setTag(Info.tag || '');
                setDivision(Info.division || '');
                setPremises(Info.premises || '');
                setFloor(Info.floor || '');
                setSiteId(Info.site_id || '');
                setRackId(Info.rack_id || '');
                setUserType(Info.user_type || '');
                setUserDepartment(Info.user_department || '');
                setEmployeeId(Info.employee_id || '');
                setemployeeName(Info.employee_name || '');
                setUserMailId(Info.user_mail_id || '');
                setFinancialsClassification(Info.financials_classification || Info.alternative_verification || '');
                setReason(Info.reason || '');
                const rawDate = Info.effective_date != null ? Info.effective_date : Info.unallocate_date;
                setEffectiveDate(getFormatedDate(rawDate));
            }
        });
    };

    const getDivisionName = (divVal) => {
        if (!divVal && divVal !== 0) return '';
        if (divisions && divisions.length > 0) {
            const found = divisions.find(d => String(d.id) === String(divVal) || String(d.division_name) === String(divVal));
            if (found) return found.division_name;
        }
        return divVal;
    };

    return (
        <div className="al-page" id="allocation-log-details-page">
            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-file-earmark-text-fill" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Allocation Log Details</h5>
                        <p className="al-page-subtitle">View detailed historical log entry for asset allocation or unallocation</p>
                    </div>
                </div>
                <div className="al-record-badge">
                    <button className="al-btn al-btn-outline al-btn-sm" onClick={() => navigate(-1)} style={{ border: 'none', background: 'transparent', padding: 0 }}>
                        <i className="bi bi-arrow-left"></i> Back to Allocation Log
                    </button>
                </div>
            </div>

            {/* Top Tag Search Card (if no tag in query) */}
            {!(Tag !== '' && Tag !== null) && (
                <div className="al-filter-card mb-3">
                    <div className="al-filter-card-header">
                        <span className="al-filter-card-title">
                            <i className="bi bi-tag-fill" /> Asset Log Search
                        </span>
                    </div>
                    <div className="al-filter-card-body">
                        <div className="al-filter-grid">
                            <div className="al-filter-group al-filter-group-wide">
                                <label className="al-filter-label">TAG</label>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <input
                                        type="text"
                                        className="al-form-input"
                                        placeholder="Enter the asset TAG"
                                        value={tag}
                                        onChange={(event) => setTag(event.target.value)}
                                        style={{ maxWidth: '300px' }}
                                    />
                                    <button onClick={getTagInfo} type="button" className="al-btn al-btn-primary">
                                        <i className="bi bi-search"></i> Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ══ DETAILS CARD ══ */}
            <div className="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-card-checklist" /> ALLOCATION DETAILS
                    </span>
                    {tag && (
                        <span className="al-showing-badge">
                            TAG: <strong>{tag}</strong>
                        </span>
                    )}
                </div>

                <div style={{ padding: '24px' }}>
                    <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Allocation No." inputValue={ainNo} readOnly="readonly" />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="TAG" inputValue={tag} readOnly="readonly" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Division" inputValue={getDivisionName(division)} readOnly="readonly" />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Premises" inputValue={premises} readOnly="readonly" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Floor" inputValue={floor} readOnly="readonly" />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Site ID" inputValue={siteId} readOnly="readonly" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Rack Id" inputValue={rackId} readOnly="readonly" />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            {/* Empty spacing column to match single allocation layout */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="User Type" inputValue={userType} readOnly="readonly" />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="User Department" inputValue={userDepartment} readOnly="readonly" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Employee ID" inputValue={employeeId} readOnly="readonly" />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Employee Name" inputValue={employeeName} readOnly="readonly" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="User Mail ID" inputValue={userMailId} readOnly="readonly" />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Eligible for Alt Verification" inputValue={financialsClassification} readOnly="readonly" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                            <FromFieldText label="Start Date of Alloc." inputValue={effectivedate} readOnly="readonly" />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                            <FromSpFieldTextArea
                                maxLength="500"
                                numRows="3"
                                label="Reason"
                                inputValue={reason}
                                readOnly="readonly"
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-12" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <button className="al-btn al-btn-outline" onClick={() => navigate(-1)}>
                                <i className="bi bi-arrow-left"></i> Back
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AllocationLogDetails;
